import React, { useEffect } from 'react'


export const Sampletests = ({ data }) => {
  return (
    <div>
      <div style={{ height: '100vh', overflowY: 'auto', paddingRight: '20px' }}>
        <div
          style={{ marginTop: '130px', marginLeft: '20px', fontSize: '20px' }}
        >
          Use a cell phone, or a PC with mic and speakers (or a headset). At the
          end of each sample you will be asked for your email address so a score
          report can be emailed to you. The report will reach you within a
          minute or two of test completion.
        </div>
        <br></br>

        <div
          style={{ marginTop: '20px', marginLeft: '20px', fontSize: '22px' }}
        >
          Item types of interest
        </div>
        <br></br>
        <ol className='sampleTests-list'>
          <li>
            <a
              //href='https://tmt-taker.herokuapp.com/?TIN=095573076&testName=General%20Testing%20Quiz%20v1&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              href='https://take.tellmethis.info/?TIN=095573076&testName=General%20Testing%20Quiz%20v1&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              target='_blank'
              begin
            >
              Test Development Concepts
            </a>
            &nbsp;&ndash; Are you familiar with these basic test development
            concepts?
          </li>

          <li>
            <a
            href='https://take.tellmethis.info/?TIN=064883518&testName=Crane%20Hand%20Signals%20v6&accountId=MFpaLrYQL&mode=C&clientLogo=true'
             // href='https://tmt-taker.herokuapp.com/?TIN=023727691&testName=NCCCO%20Demo%20v5&accountId=MFpaLrYQL&mode=C&clientLogo=true'
             // href='https://tmt-taker.herokuapp.com/?TIN=064883518&testName=Crane%20Hand%20Signals%20v6&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              target='_blank'
            >
              Crane Operator Hand Signals
            </a>
            &nbsp;&ndash; Do you know these 10 questions?
          </li>
        </ol>

        <br></br>
        <div
          style={{ marginTop: '20px', marginLeft: '20px', fontSize: '22px' }}
        >
          Skills tests you can try
        </div>
        <br></br>
        <ol className='sampleTests-list'>
          <li>
            <a
              href='https://take.tellmethis.info/?TIN=083093789&testName=Word2_Demo2&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              //href='https://tmt-taker.herokuapp.com/?TIN=083093789&testName=Word2_Demo2&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              target='_blank'
            >
              Word Skills
            </a>
            &nbsp;&ndash; An 17 question quiz on <i>Microsoft Word</i> features.
          </li>
          <li>
            <a
            href='https://take.tellmethis.info/?TIN=034121396&testName=Realtor6&accountId=MFpaLrYQL&mode=C&clientLogo=true'
            //href='https://tmt-taker.herokuapp.com/?TIN=034121396&testName=Realtor6&accountId=MFpaLrYQL&mode=C&clientLogo=true'
            // href='https://tmt-taker.herokuapp.com/?TIN=062691260&testName=Realtor5&accountId=MFpaLrYQL&mode=C&clientLogo=true'
            // href='https://tmt-taker.herokuapp.com/?TIN=033038746&testName=Realtor4&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              target='_blank'
            >
              Realtor Skills
            </a>
            &nbsp;&ndash; 5 questions any experienced realtor can answer.
          </li>
          <li>
            <a
              href='https://take.tellmethis.info/?TIN=045887357&testName=Excel%20Demo%204&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              //href='https://tmt-taker.herokuapp.com/?TIN=045887357&testName=Excel%20Demo%204&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              target='_blank'
            >
              Excel Skills
            </a>
            &nbsp;&ndash; 10 questions about <i>Microsoft Excel</i>{' '}
            functionality.
          </li>

          <li>
            <a
              href='https://take.tellmethis.info/?TIN=089274243&testName=Psycho%20Demo%20Final&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              //href='https://tmt-taker.herokuapp.com/?TIN=089274243&testName=Psycho%20Demo%20Final&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              target='_blank'
            >
              Psychometrics (full length)
            </a>
            &nbsp;&ndash; A test of psychometrics fundamentals, including
            classical test theory (CTT) and item response theory (IRT).
          </li>

          <li>
            <a
              href='https://take.tellmethis.info/?TIN=049027494&testName=GDPR_Q3&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              //href='https://tmt-taker.herokuapp.com/?TIN=027650986&testName=GDPR_Q2_Final&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              //href='https://tmt-taker.herokuapp.com/?TIN=049027494&testName=GDPR_Q3&accountId=MFpaLrYQL&mode=C&clientLogo=true'
              target='_blank'
            >
              GDPR
            </a>
            &nbsp;&ndash; Since every company administering tests must deal with
            Privacy Rights, both at home and abroad, we’ve included a sample
            dialogue quiz about GDPR.
          </li>
        </ol>
      </div>

      <br></br>
      <div
        style={{
          position: 'relative',
          marginLeft: '40px',
          fontSize: '18px',
          color: 'slateblue'
        }}
      >
        <i>
          Use a cell phone, or a PC with mic and speakers (or a headset). At the
          end of each sample you will be asked for your email address so a score
          report can be emailed to you. The report will reach you within a
          minute or two of test completion.
        </i>
      </div>
    </div>
  )
}
